// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3237":"b648418e09a95bb9e894","3351":"dfc5d4c527c3a9c2fc47"}[chunkId] + ".js";
};